import { useQuery } from '@tanstack/react-query';
import { useState } from 'react';

import { Badge } from '../../components/ui/Badge.jsx';
import { Button } from '../../components/ui/Button.jsx';
import { MetricCard } from '../../components/ui/Card.jsx';
import { Table } from '../../components/ui/Table.jsx';
import { useTranslation } from '../../i18n/useTranslation.js';
import { inventoryApi } from '../../services/inventoryApi.js';
import { formatDate } from '../../utils/formatters.js';

import { SerialDetailModal } from './SerialDetailModal.jsx';

const STATUS_VARIANT = { IN_STOCK: 'success', ISSUED: 'neutral' };

export function SerialsPage() {
  const { t } = useTranslation();
  const [q, setQ] = useState('');
  const [status, setStatus] = useState('');
  const [detailId, setDetailId] = useState(null);

  const list = useQuery({
    queryKey: ['inventory', 'serials', q, status],
    queryFn: () => inventoryApi.listSerials({ q: q || undefined, status: status || undefined }).then((r) => r.items),
  });
  const rows = list.data || [];
  const count = (s) => rows.filter((r) => r.status === s).length;

  const columns = [
    { key: 'serial', label: t('sn.col.serial'), render: (r) => <span className="mono"><strong>{r.serialNumber}</strong></span> },
    { key: 'product', label: t('sn.col.product'), render: (r) => <span><strong>{r.productSku}</strong> <span className="muted text-sm">{r.productName}</span></span> },
    { key: 'status', label: t('col.status'), render: (r) => <Badge variant={STATUS_VARIANT[r.status]}>{t(`sn.status.${r.status}`)}</Badge> },
    { key: 'updated', label: t('sn.col.updated'), render: (r) => formatDate(r.updatedAt) },
    { key: 'actions', label: '', align: 'right', render: (r) => <Button size="sm" variant="ghost" onClick={() => setDetailId(r.id)}>{t('sn.action.view')}</Button> },
  ];

  return (
    <section className="page">
      <header className="page-header">
        <div>
          <h1>{t('sn.title')}</h1>
          <p className="muted">{t('sn.subtitle')}</p>
        </div>
        <div className="page-actions">
          <input className="input" style={{ maxWidth: 220 }} placeholder={t('sn.search')} value={q} onChange={(e) => setQ(e.target.value)} />
          <select className="input" style={{ maxWidth: 160 }} value={status} onChange={(e) => setStatus(e.target.value)}>
            <option value="">{t('sn.allStatus')}</option>
            <option value="IN_STOCK">{t('sn.status.IN_STOCK')}</option>
            <option value="ISSUED">{t('sn.status.ISSUED')}</option>
          </select>
        </div>
      </header>

      <div className="card-grid">
        <MetricCard label={t('sn.metric.inStock')} value={String(count('IN_STOCK'))} trendVariant="success" />
        <MetricCard label={t('sn.metric.issued')} value={String(count('ISSUED'))} />
        <MetricCard label={t('sn.metric.total')} value={String(rows.length)} />
      </div>

      <Table columns={columns} rows={rows} isLoading={list.isLoading} emptyMessage={t('sn.empty')} />

      <SerialDetailModal serialId={detailId} onClose={() => setDetailId(null)} />
    </section>
  );
}
